<template>
    <div>
        <div class="text-center font-16 font-weight margin-bottom-15">{{$t('erp.channelbase.authorization_title', { defaultValue: '授权时，关联账号会同时被授权，确认授权？' })}}</div>
        {{$t('erp.channelbase.authorization_contact', { defaultValue: '关联账号如下：' })}}
        <vTable
            class="margin-top-15"
            :columns="columns" 
            :data="formList"
            size="small" 
            ref="tablequery"  
            border >
        </vTable>
        <div class="text-right margin-top-10">
            <vButton theme="primary" @click="submit">{{$t('erp.channelbase.goauthorization', { defaultValue: '去授权' })}}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</vButton>
        </div>
    </div>
</template>

<script>
import { HttpGetContactAccount, HttpGetAccountInterface } from "@/service/managechannel/managechannel";
export default {
    props:['activejson'],
    data(){
        return {
            formList:[],
        }
    },
    created(){
        this.getDetail();
    },
    methods:{
        getDetail(){
            HttpGetContactAccount({
                id:this.activejson.id
            }).then(res=>{
                this.formList = res.data
            },err=>{

            })
        },
        submit(){
            HttpGetAccountInterface({
                channelFlag: this.activejson.flag,type:this.activejson.type
            }).then(res=>{
                if(res.message){
                    window.open(res.message, '_blank');
                }else{
                    this.$VMessage.error({
                        content:this.$t('erp.channelbase.accountinterface_tips', { defaultValue: '此平台暂不支持授权' }),
                        duration:10,
                        closeable:true,
                    })
                }
            },err=>{
                this.$VMessage.error({
                        content:err.message,
                        duration:10,
                        closeable:true,
                    })
            })
        },
        cancel(){
            this.$emit('on-close')
        }
    },
    computed:{
        columns(){
            return [
                {
                    title: this.$t('erp.managewarehouse.shop_name', { defaultValue: "店铺名称" }),
                    key: 'flag',
                    render(h, { row }) {
                        return <div>
                        {row.flag}
                        </div>
                    }
                },
                {
                    title: this.$tc('global.common.country',1,{defaultValue:'国家'}),
                    key: 'countryCode',
                    render(h, { row }) {
                        return <div>{row.countryCode}</div>
                    }
                }, {
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: 'status',
                    render(h, { row }) {
                        return <div>{row.status}</div>
                    }
                }, 
            ]
        }
    }
}
</script>